import React, { useEffect, useState } from "react";
import { FilterManagerState } from "@v2/components/controls/FilterManager/filter-manager-state";
import {
  ConditionEditor
} from "@v2/components/controls/FilterManager/ConditionEditor/ConditionEditor";
import { ActionButton, PrimaryButton, useTheme } from "@fluentui/react";
import { observer } from "mobx-react";
import { toJS } from "mobx";
import { createStyles } from "@v2/components/controls/FilterManager/FilterManager.styles";
import { FilterCondition } from 'shared/types/flowstep';
import { RenderFieldEditorWithOperatorFunc, GetFieldOperatorsFunc } from '@v2/components/controls/FilterManager/types';
import { DataField } from 'shared/providers/types';

interface FilterManagerProps {
  objectFields: DataField[];
  conditions: FilterCondition[];
  getFieldOperators: GetFieldOperatorsFunc;
  getFieldEditor: RenderFieldEditorWithOperatorFunc,
  onApply: (conditions: FilterCondition[]) => void;
  allowEmptyValues?: boolean;
}

export const FilterManager: React.FC<FilterManagerProps> = observer((props) => {
  const { objectFields, conditions, getFieldEditor, getFieldOperators, onApply, allowEmptyValues } = props;
  const [state] = useState(new FilterManagerState(conditions, { allowEmptyValues }));
  const theme = useTheme();
  const styles = createStyles(theme);

  const handleApply = () => {
    onApply(toJS(state.conditions));
  }

  useEffect(() => {
    if (state.conditions.length === 0) {
      state.addCondition();
    }
  }, [])

  return (
    <div className={styles.filterManager}>
      <div className={styles.conditionList}>
        {state.conditions.map((condition, index) => (
          <ConditionEditor
            key={index}
            headerText={`Filter #${index + 1}`}
            condition={condition}
            objectFields={objectFields}
            renderFieldEditor={getFieldEditor}
            getPropOperators={getFieldOperators}
            showJoinOperator={index !== 0}
            onDeleteClick={() => state.deleteCondition(index)}
          />
        ))}
        <ActionButton
          iconProps={{ iconName: 'addTo' }}
          onClick={() => state.addCondition()}
        >
          Add Filter
        </ActionButton>
      </div>
      <div className={styles.bottomPanel}>
        <PrimaryButton onClick={handleApply} disabled={!state.isValid}>Apply</PrimaryButton>
      </div>
    </div>
  )
})
